import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const FREELANCER_ROLES = ['EDITOR', 'TRANSLATOR', 'DESIGNER'] as const;

/**
 * Redirects freelancer users (EDITOR/TRANSLATOR/DESIGNER) to /my-tasks,
 * all others to /dashboard. Used as the index route and catch-all fallback.
 */
export function ResourceRedirect() {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  return <Navigate to={(FREELANCER_ROLES as readonly string[]).includes(user.role) ? '/my-tasks' : '/dashboard'} replace />;
}
